import axios from 'axios';

const cancellableRequest = (request) => {
  let lastRequestSource;

  return (params) => {
    if (lastRequestSource) {
      lastRequestSource.cancel('Newer request.');
    }

    lastRequestSource = axios.CancelToken.source();
    return request(lastRequestSource.token)(params);
  };
};

export default cancellableRequest;
